import { useState,useRef, useEffect, useMemo } from "react";
import { useApi } from "../../hooks/use-api";
import {API_UPLOAD_EXCEL,API_STUDENT_DETAILS,API_DELETE_STUDENT, API_ACTIVATE_USERS, API_DEACTIVATE_USERS} from "../../utils/api-routes"
import { API_REMOVE_MULTIPLE } from "../../utils/api-routes";
import { useNotify } from "../../hooks/use-notify";

export const useHandler = () =>{
  const {post,get} = useApi()
  const {toggleNotify} = useNotify()
  const [currentPage, setCurrentPage] = useState(1);
  const [selectFile,setSelectFile] = useState();
  const [studentDetsils,setStudentDetails] = useState([])
  const [show, setShow] = useState(false)
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data,setData] = useState({
    search:"",
    selectedEmails: {} 
  })

  const pageSize = 10;
  const {search} = data

       const getStudentDetails = async() =>{
        setLoading(true);
          try{
                const res = await get(API_STUDENT_DETAILS)
                if(res){
                    setStudentDetails(res?.data)
                }
            }catch(e){
               console.log("failded fetched student details",e)
          } finally
          {
            setLoading(false);
          }
      } 

const uploadExcel = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const res = await post(API_UPLOAD_EXCEL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

   
    const report = res?.data?.report;

    if (report?.failed_count > 0) {
      toggleNotify({
        type: "error",
        title: "Upload Failed",
        description: `${report.failed_count} rows failed to upload`,
      });

      console.log(report.failed);
      return;
    }

    toggleNotify({
      type: "success",
      title: "Success",
      description: "Student data uploaded successfully",
    });

    getStudentDetails();
  } catch (e) {
    console.log("Upload failed:", e);

    toggleNotify({
      type: "error",
      title: "Error",
      description: "Something went wrong",
    });
  }
};

      useEffect(()=>{
        getStudentDetails()
      },[])
  
   const studentSearchDetails = useMemo(() => {
  const users = studentDetsils?.users || []

  if (!search) return users

  return users.filter(({ Name, Mail }) =>
    Name?.toLowerCase()?.includes(search.toLowerCase()) ||
    Mail?.toLowerCase()?.includes(search.toLowerCase())
  )
}, [studentDetsils, search])

    const onChangeValue = (e) =>{
        const {value,name,checked,type} = e.target
      //  setSearch(value)
      setData((prev)=> ({...prev,[name]: type === 'checkbox' ? checked : value}))
    }

  const onChangeFile = async(e) =>{
     const file = e.target.files[0];
    if(!file) return 
    setSelectFile(file)
   await uploadExcel(file)

   e.target.value = ""
  }

  const onDelete = async(email) =>{
       try{
           const res = await post(API_DELETE_STUDENT,{email:email});
           if(res){
              // alert(res?.data?.message)
              toggleNotify({
              type: "success",
              title: "Student Deleted",
              description: "Student removed successfully",
             })
              getStudentDetails()
           }
       }catch(e){
           console.log("delete api error",e)
       } 
  }

  const handleCheckboxChange = (email) => {
  setData(prev => ({
    ...prev,
    selectedEmails: {
      ...prev.selectedEmails,
      [email]: !prev.selectedEmails[email]
    }
  }));
};

const getSelectedEmails = () =>
  Object.keys(data.selectedEmails).filter(
    email => data.selectedEmails[email]
  );


    const removeMultiple = async() =>{
        const emails = getSelectedEmails();

          if (!emails.length) {
            // alert("Please select at least one student");
            toggleNotify({
              type: "error",
              description: "Please select at least one student",
           })
            return;
          }

          const payload = {
             emails
          };
         try{
            const res = await post(API_REMOVE_MULTIPLE,payload)
            if(res) {
            //  alert(res?.data?.message || "Students removed");
            toggleNotify({
              type: "success",
              title: "Student Deleted",
              description: "Student removed successfully",
             })
              setData(prev => ({ ...prev, selectedEmails: {} }));
              getStudentDetails();
            }
         }catch(e){
            console.log("Error comes from removedetails",e)
         }
      }

      const clearSelectedEmails = () =>{
        setData((prev)=> ({...prev,selectedEmails:{}}))
      }

      const activateUsers = async() =>{
            const emails = getSelectedEmails();
            if(!emails.length) {
              toggleNotify({
                  type: "error",
                  description: "Please select at least one student",
              })
              return;
            }

            const payload = {
              emails
            }
            try{
               const res = await post(API_ACTIVATE_USERS, payload)
                  if(res){
                    toggleNotify({
                      type: "success",
                      title: "Success",
                      description: "Email activated SuccessFully",
                    })
                    setData((prev)=>  ({...prev, selectedEmails:{}}))
                }

            }catch(e){
                console.log("ERROR COMES FROM ACTIVATE USERS",e)
            }
      }


         const deActivateUsers = async() =>{
            const emails = getSelectedEmails();
            if(!emails.length) {
              toggleNotify({
                  type: "error",
                  description: "Please select at least one student",
              })
              return;
            }

            const payload = {
              emails
            }
            try{
               const res = await post(API_DEACTIVATE_USERS, payload)
                  if(res){
                    toggleNotify({
                      type: "success",
                      title: "Success",
                      description: "Email deactivated SuccessFully",
                    })
                    setData((prev)=>  ({...prev, selectedEmails:{}}))
                }

            }catch(e){
                console.log("ERROR COMES FROM DEACTIVATE USERS",e)
            }
      }
      

      return{ 
        fileInputRef,
        currentPage,
        search,
        studentSearchDetails,
        pageSize,
        data,
        show,
        toggleNotify,
        handleCheckboxChange,
        setData,
        onDelete,
        onChangeValue,
        setCurrentPage,
        getStudentDetails,
        onChangeFile,
        removeMultiple,
        setShow,
        clearSelectedEmails,
        activateUsers,
        deActivateUsers,
        getSelectedEmails,
        studentDetsils,
        loading
    }
}